module.exports = __webpack_public_path__ + "static/media/Nagend.568c1c5a.jpg";